import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

// Icons should always be lazy loaded, meaning a function that returns a Promise with the SVG markup.
const LOGOS = {
    mark: async () => await import('./mark.js'),
    'mark-text': async () => await import('./mark-text.js'),
    'mark-slogan': async () => await import('./mark-slogan.js'),
    'mark-text-slogan': async () => await import('./mark-text-slogan.js'),
};

const LOGO_NAMES = ['mark', 'mark-slogan', 'mark-text', 'mark-text-slogan'];

const logoCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:-webkit-fit-content;width:fit-content}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host div>svg{width:auto}:host([type=color][name=mark-slogan]) .brandmark-jwp,:host([type=color][name=mark-text-slogan]) .brandmark-jwp,:host([type=color][name=mark-text]) .brandmark-jwp,:host([type=color][name=mark]) .brandmark-jwp{fill:var(--jw-theme-brand-theme-brand-jwp-red)}:host .brandmark-x{fill:var(--jw-theme-brand-theme-brand-x)}:host .brandmark-connatix-blue{fill:#4890cd}:host([type=color][name=mark-slogan]) .brandmark-connatix,:host([type=color][name=mark-slogan]) .brandmark-text,:host([type=color][name=mark-text-slogan]) .brandmark-connatix,:host([type=color][name=mark-text-slogan]) .brandmark-text,:host([type=color][name=mark-text]) .brandmark-connatix,:host([type=color][name=mark-text]) .brandmark-text,:host([type=color][name=mark]) .brandmark-connatix,:host([type=monochrome]) .brandmark-connatix,:host([type=monochrome]) .brandmark-connatix-blue,:host([type=monochrome]) .brandmark-jwp,:host([type=monochrome]) .brandmark-text{fill:var(--jw-theme-brand-theme-brand-mono)}:host([size=\"2xs\"]) div{height:.75rem}:host([size=\"2xs\"]) div>svg{height:100%}:host([size=xs]) div{height:1rem}:host([size=xs]) div>svg{height:100%}:host([size=sm]) div{height:1.5rem}:host([size=sm]) div>svg{height:100%}:host([size=md]) div{height:2rem}:host([size=md]) div>svg{height:100%}:host([size=lg]) div{height:2.5rem}:host([size=lg]) div>svg{height:100%}:host([size=xl]) div{height:3rem}:host([size=xl]) div>svg{height:100%}:host([size=\"2xl\"]) div{height:4.5rem}:host([size=\"2xl\"]) div>svg{height:100%}";
const WuiLogoStyle0 = logoCss;

const getLogoSvg = async (name) => {
    if (name === 'NULL' || typeof name === 'undefined' || !LOGO_NAMES.includes(name))
        return '';
    const fn = LOGOS[name];
    const ret = await fn();
    return ret.default;
};
const WuiLogo = /*@__PURE__*/ proxyCustomElement(class WuiLogo extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.name = undefined;
        this.type = 'monochrome';
        this.size = undefined;
        this.svg = '';
    }
    // We lazy load all SVGs by watching when the `name` property changes.
    // We then request the icon asynchronously, and once its loaded, we replace
    // the internal state with the new SVG markup.
    async watchName() {
        this.svg = await getLogoSvg(this.name);
    }
    componentWillLoad() {
        // Load the initial SVG by triggering the watch function
        this.watchName();
    }
    render() {
        return (h(Host, { key: 'f2e9a83ff0efba27a639ab31bbc77e50fdb6f336' }, h("div", { key: '0e399eec2d0c48437d861f7f4de287cb62fd5413', innerHTML: this.svg })));
    }
    static get watchers() { return {
        "name": ["watchName"]
    }; }
    static get style() { return WuiLogoStyle0; }
}, [1, "wui-logo", {
        "name": [513],
        "type": [513],
        "size": [513],
        "svg": [32]
    }, undefined, {
        "name": ["watchName"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-logo"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-logo":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiLogo);
            }
            break;
    } });
}
defineCustomElement();

export { WuiLogo as W, defineCustomElement as d };

//# sourceMappingURL=logo.js.map